const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls, useAutoplay } =
  window.BAO.Carousel.plugins

class HeaderCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
        useAutoplay(this.cadence, { pauseOnHover: true }),
      ],
    )
  }

  get cadence () {
    return this.dataset.cadence || 4
  }
}

if (!customElements.get('header-carousel')) {
  customElements.define('header-carousel', HeaderCarousel)
}
